<div class="sri-banner__container">
    @if (showCurrency) {
        <div class="sri-banner__container__risk-level" data-test="sri-banner-currency">
            <span>GBP SRI {{ riskLevel }}</span>
            @if (riskLevel === 1) {
                &nbsp;-&nbsp;Liquid Reserves
            }
        </div>
    }
    <nw-icon
        icon="SRI"
        class="sri-banner__container__icon"
        data-test="sri-banner-icon"
    ></nw-icon>
</div>
